export default class PaymentProvider {
    constructor({id = 0, name = '', isActive = false, countries = []} = {}) {
        this.id = id;
        this.name = name;
        this.isActive = isActive;
        this.countries = countries;
    }
}
